export class VehicleModelDto {

    id: number;
    vehicleModel: string;
    isActive: boolean;
    createdUser: string | null;
    createdAt: Date;
    updatedUser: string | null;
    updatedAt: Date;
    versionFlag: number;
    vehicleCategory: number;

    constructor(
        id: number,
        vehicleModel: string,
        isActive: boolean,
        createdUser: string | null,
        createdAt: Date,
        updatedUser: string | null,
        updatedAt: Date,
        versionFlag: number,
        vehicleCategory: number
    ) {
        this.id = id;
        this.vehicleModel = vehicleModel;
        this.isActive = isActive;
        this.createdUser = createdUser;
        this.createdAt = createdAt;
        this.updatedUser = updatedUser;
        this.updatedAt = updatedAt;
        this.versionFlag = versionFlag;
        this.vehicleCategory = vehicleCategory;
    }
}
